var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    [
      _c("PageHeader", { attrs: { title: _vm.title, items: _vm.items } }),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Order Name",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "order-name"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "order-name", trim: "" },
                                model: {
                                  value: _vm.search_condition.orderName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "orderName",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.orderName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Order No.",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "order-number"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "order-number", trim: "" },
                                model: {
                                  value: _vm.search_condition.number,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "number",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.number"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Model Name",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "model-name"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "model-name", trim: "" },
                                model: {
                                  value: _vm.search_condition.modelName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "modelName",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.modelName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Production Time",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "create-time"
                              }
                            },
                            [
                              _c("date-picker", {
                                attrs: {
                                  format: "MM/DD/YYYY",
                                  range: "",
                                  "append-to-body": "",
                                  lang: "en",
                                  placeholder: "Select date"
                                },
                                model: {
                                  value: _vm.createTime,
                                  callback: function($$v) {
                                    _vm.createTime = $$v
                                  },
                                  expression: "createTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Status",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "order-status"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "order-status",
                                  options: _vm.types.statuss
                                },
                                model: {
                                  value: _vm.search_condition.status,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.search_condition,
                                      "status",
                                      $$v
                                    )
                                  },
                                  expression: "search_condition.status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Cartridge Type",
                                "label-cols-sm": "4",
                                "label-align-sm": "right",
                                "label-for": "order-type"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "order-type",
                                  options: _vm.types.cartridgeType,
                                  "text-field": "name",
                                  "value-field": "id"
                                },
                                model: {
                                  value: _vm.search_condition.type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.search_condition, "type", $$v)
                                  },
                                  expression: "search_condition.type"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { lg: "4" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.search()
                                }
                              }
                            },
                            [_vm._v("Search")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-card",
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "emptyCartridgeProductionOrders::Create",
                          expression: "'emptyCartridgeProductionOrders::Create'"
                        },
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.modal-center",
                          modifiers: { "modal-center": true }
                        }
                      ],
                      attrs: { variant: "primary" }
                    },
                    [_vm._v("Create")]
                  ),
                  _c(
                    "div",
                    { staticClass: "table-responsive mb-0" },
                    [
                      _c("b-table", {
                        ref: "table",
                        attrs: {
                          id: "device-table",
                          "head-variant": "light",
                          "show-empty": "",
                          "empty-text": "no records",
                          busy: _vm.isBusy,
                          striped: true,
                          items: _vm.provider,
                          fields: _vm.fields,
                          "per-page": _vm.search_condition.pageSize,
                          "current-page": _vm.search_condition.pageNum,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          filter: _vm.filter,
                          "filter-includedfields": _vm.filterOn
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center text-danger my-2"
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "align-middle"
                                    }),
                                    _c("strong", [_vm._v("Loading...")])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(index)",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      data.index +
                                        (_vm.search_condition.pageNum - 1) *
                                          _vm.search_condition.pageSize +
                                        1
                                    ) +
                                    " "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(actions)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-button-group",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "has",
                                            rawName: "v-has",
                                            value:
                                              "emptyCartridgeProductionOrders::Details",
                                            expression:
                                              "'emptyCartridgeProductionOrders::Details'"
                                          }
                                        ],
                                        staticClass: "mr-1",
                                        attrs: {
                                          size: "sm",
                                          variant: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.show(
                                              row.item,
                                              row.index,
                                              $event.target
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(" Details ")]
                                    ),
                                    row.item.status == 0 ||
                                    row.item.status == 11 ||
                                    row.item.status == 21
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "has",
                                                rawName: "v-has",
                                                value:
                                                  "emptyCartridgeProductionOrders::Close",
                                                expression:
                                                  "'emptyCartridgeProductionOrders::Close'"
                                              }
                                            ],
                                            staticClass: "mr-1",
                                            attrs: {
                                              size: "sm",
                                              variant: "danger"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onClickClose(
                                                  row.item,
                                                  row.index,
                                                  $event.target
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" Close ")]
                                        )
                                      : _vm._e(),
                                    row.item.type == 7 &&
                                    row.item.productionType == 2
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "has",
                                                rawName: "v-has",
                                                value: "qrCode::Down",
                                                expression: "'qrCode::Down'"
                                              }
                                            ],
                                            staticClass: "mr-1",
                                            attrs: {
                                              size: "sm",
                                              variant: "info",
                                              disabled: _vm.dowmDisable
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.dowmQrCode(
                                                  row.item,
                                                  row.index,
                                                  $event.target
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" Down ")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm.has_data
                    ? _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dataTables_paginate paging_simple_numbers float-right"
                              },
                              [
                                _vm.rows != 0
                                  ? _c(
                                      "ul",
                                      { staticClass: "pagination mb-0" },
                                      [
                                        _c("b-pagination", {
                                          ref: "page",
                                          attrs: {
                                            "per-page": 10,
                                            "total-rows": _vm.rows,
                                            "aria-controls": "table"
                                          },
                                          model: {
                                            value: _vm.search_condition.pageNum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.search_condition,
                                                "pageNum",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "search_condition.pageNum"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "modal-center", centered: "", title: "Please Select" },
          on: { ok: _vm.modalOk }
        },
        [
          _c("p", { staticClass: "my-4" }, [
            _vm._v(
              " Please select the cartridge type which one you want to production "
            )
          ]),
          _c(
            "ul",
            { staticClass: "options-box modal-list" },
            _vm._l(_vm.itemList, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "modal-item",
                  class: { selected: _vm.readySelectItem === index },
                  on: {
                    click: function($event) {
                      return _vm.selectItem(item, index)
                    }
                  }
                },
                [
                  _c("img", { attrs: { src: item.src } }),
                  _c("span", { staticClass: "modal-msg" }, [
                    _vm._v(_vm._s(item.title))
                  ])
                ]
              )
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }